export const hasOrcasAccess = (state): boolean => state.hasOrcasAccess

export const tokenIsValid = (state): boolean => state.tokenIsValid

export const selectedCookies = (state): Array<string> => state.selectedCookies
